import { Inject, Injectable } from '@angular/core';
import { ErrorMessageModel } from '../../objects/general/error-message/error-message-model';
import { CpErrorInternalModel } from '../../objects/general/error-internal/error-internal-model';
import { Message } from 'primeng/api';
import { SharedEventsService } from '@fh-client-interaction-frontends/fh-providers';
import { TranslateService } from '@ngx-translate/core';
import { APP_CONFIG, EnvironmentModel } from '@fh-client-interaction-frontends/fh-app-config';

@Injectable({
  providedIn: 'root'
})
export class CpErrorManagementProviderService {
  appConfig: EnvironmentModel = new EnvironmentModel();
  ignoreErrosList: number[] = [-111];
  errorsListArray: Array<ErrorMessageModel> = [
    { resultCode: '-108', errorMessage: 'fhcp.error.api.missing_request_data' },
    { resultCode: '-109', errorMessage: 'fhcp.error.api.invalid_request_data' },
    { resultCode: '-420', errorMessage: 'fhcp.error.api.invalid_request_dat' },
    { resultCode: '-421', errorMessage: 'fhcp.error.api.invalid_request_dat' },
    { resultCode: '-422', errorMessage: 'fhcp.error.api.invalid_request_dat' },
    { resultCode: '-424', errorMessage: 'fhcp.error.api.invalid_request_dat' },
    { resultCode: '-425', errorMessage: 'fhcp.error.api.invalid_request_dat' },
    { resultCode: '-426', errorMessage: 'fhcp.error.api.invalid_request_dat' },
    { resultCode: '-110', errorMessage: 'fhcp.error.api.not_found' },
    { resultCode: '-427', errorMessage: 'fhcp.error.api.not_found' },
    { resultCode: '-431', errorMessage: 'fhcp.error.api.not_found' },
    { resultCode: '-460', errorMessage: 'fhcp.error.api.not_found' },
    { resultCode: '-461', errorMessage: 'fhcp.error.api.not_found' },
    { resultCode: '-471', errorMessage: 'fhcp.error.api.not_found' },
    { resultCode: '-508', errorMessage: 'fhcp.error.api.not_found' },
    { resultCode: '-509', errorMessage: 'fhcp.error.api.not_found' },
    { resultCode: '-111', errorMessage: 'fhcp.error.api.virtual_card_not_found' },
    { resultCode: '-113', errorMessage: 'fhcp.error.api.register_already_exists' },
    { resultCode: '-114', errorMessage: 'fhcp.error.api.token_not_exist' },
    { resultCode: '-115', errorMessage: 'fhcp.error.api.token_has_password' },
    { resultCode: '-116', errorMessage: 'fhcp.error.api.token_used' },
    { resultCode: '-117', errorMessage: 'fhcp.error.api.register' },
    { resultCode: '-118', errorMessage: 'fhcp.error.api.invalid_contract_association' },
    { resultCode: '-119', errorMessage: 'fhcp.error.api.invalid_file_name' },
    { resultCode: '-401', errorMessage: 'fhcp.error.api.fields_mandatory' },
    { resultCode: '-402', errorMessage: 'fhcp.error.api.fields_mandatory' },
    { resultCode: '-403', errorMessage: 'fhcp.error.api.fields_mandatory' },
    { resultCode: '-404', errorMessage: 'fhcp.error.api.fields_mandatory' },
    { resultCode: '-405', errorMessage: 'fhcp.error.api.fields_mandatory' },
    { resultCode: '-406', errorMessage: 'fhcp.error.api.fields_mandatory' },
    { resultCode: '-407', errorMessage: 'fhcp.error.api.fields_mandatory' },
    { resultCode: '-408', errorMessage: 'fhcp.error.api.fields_mandatory' },
    { resultCode: '-409', errorMessage: 'fhcp.error.api.fields_mandatory' },
    { resultCode: '-410', errorMessage: 'fhcp.error.api.fields_mandatory' },
    { resultCode: '-411', errorMessage: 'fhcp.error.api.fields_mandatory' },
    { resultCode: '-412', errorMessage: 'fhcp.error.api.fields_mandatory' },
    { resultCode: '-413', errorMessage: 'fhcp.error.api.fields_mandatory' },
    { resultCode: '-414', errorMessage: 'fhcp.error.api.fields_mandatory' },
    { resultCode: '-415', errorMessage: 'fhcp.error.api.fields_mandatory' },
    { resultCode: '-416', errorMessage: 'fhcp.error.api.fields_mandatory' },
    { resultCode: '-417', errorMessage: 'fhcp.error.api.fields_mandatory' },
    { resultCode: '-418', errorMessage: 'fhcp.error.api.fields_mandatory' },
    { resultCode: '-419', errorMessage: 'fhcp.error.api.fields_mandatory' },
    { resultCode: '-429', errorMessage: 'fhcp.error.api.fields_mandatory' },
    { resultCode: '-428', errorMessage: 'fhcp.error.api.repeated_refund_receipt' },
    { resultCode: '-470', errorMessage: 'fhcp.error.api.invalid_date_of_encounter' },
    { resultCode: '-472', errorMessage: 'fhcp.error.api.patient_inactive_date_of_encounter' },
    { resultCode: '-473', errorMessage: 'fhcp.error.api.submission_deadline_expired' },
    { resultCode: '-474', errorMessage: 'fhcp.error.api.submission_start_date_invalid' },
    { resultCode: '-475', errorMessage: 'fhcp.error.api.invalid_amount' },
    { resultCode: '-503', errorMessage: 'fhcp.error.api.invalid_data' },
    { resultCode: '-504', errorMessage: 'fhcp.error.api.invalid_login_data' },
    { resultCode: '-505', errorMessage: 'fhcp.error.api.invalid_token' },
    { resultCode: '-507', errorMessage: 'fhcp.error.api.invalid_change_refund_iban_response' },
    { resultCode: '-510', errorMessage: 'fhcp.error.api.victoria_digital_archive_error' },
    { resultCode: '-513', errorMessage: 'fhcp.error.api.register_already_exists' },
    { resultCode: '-552', errorMessage: 'fhcp.error.api.mps_error_invalid_fiscal_number' },
    { resultCode: '-553', errorMessage: 'fhcp.error.api.mps_error_invalid_niss' },
    { resultCode: '-554', errorMessage: 'fhcp.error.api.mps_error_invalid_file' },
    { resultCode: '-555', errorMessage: 'fhcp.error.api.mps_error_invalid_file' },
    { resultCode: '-556', errorMessage: 'fhcp.error.api.mps_error_invalid_file' },
    { resultCode: '-557', errorMessage: 'fhcp.error.api.mps_error_invalid_date_file' },
    { resultCode: '-558', errorMessage: 'fhcp.error.api.mps_error_invalid_date_file' },
    { resultCode: '-559', errorMessage: 'fhcp.error.api.mps_error_invalid_beneficiaries_file' },
    { resultCode: '-560', errorMessage: 'fhcp.error.api.mps_error_invalid_drm_file' },
    { resultCode: '-561', errorMessage: 'fhcp.error.api.mps_error_invalid_files' },
    { resultCode: '-562', errorMessage: 'fhcp.error.api.mps_error_invalid_emp_contributive' },
    { resultCode: '-563', errorMessage: 'fhcp.error.api.mps_error_invalid_fam_contributive' },
    { resultCode: '-564', errorMessage: 'fhcp.error.api.mps_error_invalid_ret_contributive' },
    { resultCode: '-565', errorMessage: 'fhcp.error.api.mps_error_unexpected_beneficiaries_file_type' },
    { resultCode: '-566', errorMessage: 'fhcp.error.api.mps_error_unexpected_drm_file_type' },
    { resultCode: '-568', errorMessage: 'fhcp.error.api.mps_error_invalid_beneficiaries_file_company_fiscal_number' },
    { resultCode: '-569', errorMessage: 'fhcp.error.api.mps_error_invalid_beneficiary_company_fiscal_number' },
    { resultCode: '-567', errorMessage: 'fhcp.error.api.mps_error_processing_beneficiaries_file' },
    { resultCode: '-570', errorMessage: 'fhcp.error.api.mps_error_invalid_beneficiary_main_person_niss' },
    { resultCode: '-571', errorMessage: 'fhcp.error.api.mps_error_invalid_beneficiary_fiscal_number' },
    { resultCode: '-572', errorMessage: 'fhcp.error.api.mps_error_invalid_beneficiary_relationship' },
    { resultCode: '-573', errorMessage: 'fhcp.error.api.mps_error_invalid_beneficiary_gender' },
    { resultCode: '-574', errorMessage: 'fhcp.error.api.mps_error_invalid_beneficiary_birth_date' },
    { resultCode: '-575', errorMessage: 'fhcp.error.api.mps_error_invalid_beneficiary_contract_type' },
    { resultCode: '-576', errorMessage: 'fhcp.error.api.mps_error_invalid_address' },
    { resultCode: '-577', errorMessage: 'fhcp.error.api.mps_error_invalid_beneficiary_postal_code' },
    { resultCode: '-578', errorMessage: 'fhcp.error.api.mps_error_invalid_local' },
    { resultCode: '-579', errorMessage: 'fhcp.error.api.mps_error_invalid_beneficiary_mobile' },
    { resultCode: '-580', errorMessage: 'fhcp.error.api.mps_error_invalid_beneficiary_email' },
    { resultCode: '-581', errorMessage: 'fhcp.error.api.mps_error_invalid_beneficiary_iban' },
    { resultCode: '-582', errorMessage: 'fhcp.error.api.mps_error_invalid_line' },
    {
      resultCode: '-583',
      errorMessage: 'fhcp.error.api.mps_error_monthly_remuneration_statement_file_found_second_enterprise_record_line'
    },
    {
      resultCode: '-584',
      errorMessage: 'fhcp.error.api.mps_error_monthly_remuneration_statement_file_remuneration_record_without_associated_enterprise'
    },
    {
      resultCode: '-585',
      errorMessage: 'fhcp.error.api.mps_error_monthly_remuneration_statement_file_duplicate_enterprise_total_record'
    },
    {
      resultCode: '-586',
      errorMessage: 'fhcp.error.api.mps_error_monthly_remuneration_statement_file_total_remuneration_does_not_match_total_contributions_enterprise_total_record'
    },
    {
      resultCode: '-587',
      errorMessage: 'fhcp.error.api.mps_error_monthly_remuneration_statement_file_total_enterprise_records_do_not_match_number_of_records_found'
    },
    {
      resultCode: '-588',
      errorMessage: 'fhcp.error.api.mps_error_monthly_remuneration_statement_file_empty_line_found'
    },
    {
      resultCode: '-589',
      errorMessage: 'fhcp.error.api.mps_error_monthly_remuneration_statement_file_record_type_not_found_in_the_line'
    },
    {
      resultCode: '-590',
      errorMessage: 'fhcp.error.api.mps_error_monthly_remuneration_statement_file_new_header_record_found'
    },
    {
      resultCode: '-591',
      errorMessage: 'fhcp.error.api.mps_error_monthly_remuneration_statement_file_first_line_not_header_record'
    },
    {
      resultCode: '-592',
      errorMessage: 'fhcp.error.api.mps_error_monthly_remuneration_statement_unidentified_employee_or_retired_beneficiary'
    },
    {
      resultCode: '-593',
      errorMessage: 'fhcp.error.api.mps_error_beneficiaries_unidentified_employee_for_family_main_person_niss'
    },
    { resultCode: '-594', errorMessage: 'fhcp.error.api.mps_error_beneficiaries_employee_same_niss_different_nif' },
    {
      resultCode: '-595',
      errorMessage: 'fhcp.error.api.mps_error_beneficiaries_unidentified_employee_for_family_main_person_niss_check'
    },
    { resultCode: '-596', errorMessage: 'fhcp.error.api.mps_error_exclusion_card_number_does_not_belong_enterprise' },
    { resultCode: '-597', errorMessage: 'fhcp.error.api.mps_error_unidentified_beneficiary_to_exclude_by_card_number' },
    { resultCode: '-598', errorMessage: 'fhcp.error.api.mps_error_quota_data_integrity_missing_active_beneficiary' },
    { resultCode: '-599', errorMessage: 'fhcp.error.api.mps_error_invalid_phone' },
    { resultCode: '-600', errorMessage: 'fhcp.error.api.mps_error_enterprise_fiscal_number_or_niss_already_exists' },
    { resultCode: '-601', errorMessage: 'fhcp.error.api.mps_error_missing_ac_entity_id' },
    { resultCode: '-602', errorMessage: 'fhcp.error.api.mps_error_invalid_ac_entity_id' },
    { resultCode: '-603', errorMessage: 'fhcp.error.api.generic' },
    { resultCode: '-604', errorMessage: 'fhcp.error.api.mps_error_invalid_enterprise_id' },
    { resultCode: '-605', errorMessage: 'fhcp.error.api.mps_error_missing_beneficiaries_file' },
    { resultCode: '-606', errorMessage: 'fhcp.error.api.mps_error_missing_monthly_remuneration_statement_file' },
    {
      resultCode: '-607',
      errorMessage: 'fhcp.error.api.mps_error_missing_beneficiaries_and_monthly_remuneration_statement_files'
    },
    { resultCode: '-608', errorMessage: 'fhcp.error.api.mps_error_missing_beneficiaries_filename' },
    { resultCode: '-609', errorMessage: 'fhcp.error.api.mps_error_missing_monthly_remuneration_statement_filename' },
    { resultCode: '-610', errorMessage: 'fhcp.error.api.mps_error_invalid_banking_fiscal_number' },
    { resultCode: '-611', errorMessage: 'fhcp.error.api.mps_error_invalid_banking_iban' },
    { resultCode: '-430', errorMessage: 'fhcp.error.api.password' },
    { resultCode: '-499', errorMessage: 'fhcp.error.api.validation_not_passed' },
    { resultCode: '-500', errorMessage: 'fhcp.error.api.generic' },
    { resultCode: '-501', errorMessage: 'fhcp.error.api.generic' },
    { resultCode: '-502', errorMessage: 'fhcp.error.api.password' },
    { resultCode: '-506', errorMessage: 'fhcp.error.api.password' },
    { resultCode: '-514', errorMessage: 'fhcp.error.api.generic' },
    { resultCode: '-551', errorMessage: 'fhcp.error.api.generic' },
    {
      resultCode: '-615',
      errorMessage: 'fhsp.error.api.mps_error_invalid_beneficiary_admission_date'
    },
    {
      resultCode: '-616',
      errorMessage: 'fhsp.error.api.mps_error_duplicated_beneficiary_fiscal_number'
    },
    {
      resultCode: '-617',
      errorMessage: 'fhsp.error.api.mps_error_invalid_beneficiary_base_salary_amount'
    },
    { resultCode: '-476', errorMessage: 'fhcp.error.api.invalid_beneficiary' },
    { resultCode: '-477', errorMessage: 'fhcp.error.api.beneficiary_inactive_on_policy_date' }
  ];

  detailMessage: string = '';

  constructor(
    @Inject(APP_CONFIG) appConfigTemp: EnvironmentModel,
    private sharedEventsService: SharedEventsService,
    private translateService: TranslateService
  ) {
    this.appConfig = appConfigTemp;
  }

  GetError(err: any): CpErrorInternalModel {
    const error: CpErrorInternalModel = new CpErrorInternalModel();

    error.httpStatus = err?.status ?? err?.error?.httpStatusCode;
    error.resultCode = err?.error?.resultCode;
    error.message = 'fhcp.error.api.generic_error';

    if (this.ignoreErrosList?.some((code: any) => String(code) === String(error.resultCode))) {
      this.emitToast(this.translateService.instant('generics.error'), this.translateService.instant(error.message));
      return error;
    }

    if (error.resultCode != null) {
      const main = this.errorsListArray.find((item: ErrorMessageModel) => item.resultCode === String(error.resultCode));
      if (main) error.message = main.errorMessage;
    }

    // Build one detail line per detail, using only the 2nd element if two exist; otherwise the 1st
    const details: string[] = [];
    const resultCodeDetail = err?.error?.resultCodeDetail;

    if (Array.isArray(resultCodeDetail) && resultCodeDetail.length > 0) {
      for (const detail of resultCodeDetail) {
        const detailCode = detail?.resultCode;
        const mapped = this.errorsListArray.find(
          (item: ErrorMessageModel) => item.resultCode === String(detailCode)
        );

        if (mapped) {
          const baseKey = mapped.errorMessage;
          const picked = this.getLineNumber(detail?.data);

          if (picked) {
            const line = this.translateService.instant(baseKey, { variable: picked });
            details.push(line);
          } else {
            details.push(this.translateService.instant(baseKey));
          }
        }
      }
    }



    const header = this.translateService.instant('generics.error');
    const mainMessage = this.translateService.instant(error.message);

    this.detailMessage = details.length
      ? `${mainMessage}\n\n${details.map((m) => `• ${m}`).join('\n')}`
      : mainMessage;


    this.emitToast(header, this.detailMessage);
    return error;
  }

  // returns only the number of the line
  private getLineNumber(data: any): string {
    if (!Array.isArray(data) || data.length === 0) return '';
    const raw = data.length >= 2 ? data[1] : data[0];
    if (raw === null || raw === undefined) return '';
    const val = String(raw).trim();
    return val.length ? val : '';
  }


  private emitToast(summary: string, detail: string): void {
    const msg: Message = {
      key: 'tr',
      severity: 'error',
      summary,
      detail,
      life: this.appConfig.toastrDuration
    };
    this.sharedEventsService.emitToasterEvent(msg);
  }
}
